import React, { useEffect, useState} from "react"
import { appStore } from "lib/state"
import { appTools, cn, randoms } from "lib/utils"
import { getDragPayload, clearDragPayload } from "lib/utils/dragstore"
import { useConditional, ConditionalGroupBlock } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"

export default function ConditionalRow({ row }:{ row:any }){

  const { store, AppStore }:any = appStore()
  const { apiValueLookup, openModal, putItemInSpotlight, loadStatementIntoZone, populateDropzone, setActiveZone }:any = useConditional()
  const { currentConditional, updateConditional }:any = useConditionalCtx()
  
  const { update }:any = AppStore

  const [ testResult, setTestResult ] = React.useState<any>()


  function parseTestResults(){
    const foundZone = store.metas.conditionalTest?.breakdown.zones.find( (zone:any) => zone.zoneref === row.zoneref )
    if( foundZone ){
      setTestResult(foundZone.verdict)
    }
  }

  async function handleDrop(e:any){
    e.preventDefault()
    let data:any
    const pkg = JSON.parse(e.dataTransfer.getData("text/plain"));
    
    if( !pkg || pkg.stashed !== undefined ){
      const {stashed} = JSON.parse(e.dataTransfer.getData("text/plain"));
      data = getDragPayload(stashed)
      clearDragPayload(stashed)
    } else {
      data = pkg
    }

    if(data.from === "loader"){
      const itemValueIds = data.items.map( (item:any) => item.api_value_id )
      console.log(itemValueIds)
      const apiValueObjs = await apiValueLookup(itemValueIds)
      const newItems = data.items.map( (item:any) => {
        if( item.api_value_id === undefined ) return item
        return {
          refid: item.refid,
          source: "api",
          location: "dropzone",
          conversion: item.conversion,
          operator: item.operator,
          tag: item.tag,
          alias: item.alias,
          value: item.value,
          apiValueObj: apiValueObjs.find( (obj:any) => obj._id === item.api_value_id )
        }
      })

      console.log(currentConditional)
      
      let updatedConditional = (currentConditional !== null) 
        ? {...currentConditional } 
        : { source_id: "", name: "", description: "", clipboard: [], zones: [], items: [] }

      if( updatedConditional.zones === undefined ) updatedConditional.zones = []
      if( updatedConditional.items === undefined ) updatedConditional.items = []

      if( row.zoneref !== "000" ){
        updatedConditional = {
          ...updatedConditional,
          zones:  updatedConditional.zones.map( (zone:any) => {
            if ( zone.zoneref !== row.zoneref ) return zone 
            return {
              ...zone,
              groups: [...zone.groups.filter( (grp:any) => grp.groupref.length > 0), ...data.zones[0].groups.filter( (grp:any) => grp.groupref.length > 0)]
            }
          }),
          items: [...updatedConditional.items, ...newItems]
        }
      } else {
        updatedConditional = {
          ...updatedConditional,
          zones: [...updatedConditional.zones, ...data.zones],
          items: [...updatedConditional.items, ...newItems]
        }
      }
      console.log(updatedConditional)
      updateConditional({...updatedConditional})
    } else {
      if( data.groupref !== undefined ) return 
      loadStatementIntoZone({ zone: row, data: data })
    }
  }

  function handleDragOver(e:any){
    e.preventDefault()
  }

  // function handleZoneClick(){
  //   setActiveZone(row.zoneref)
  //   openModal()
  // }

  useEffect(() => {
    if( store.metas.conditionalTest ){
      parseTestResults()
    } else {
      setTestResult(undefined)
    }
  },[store.metas.conditionalTest])

  return (
    <div 
      className={cn(
        "w-full min-h-12 flex flex-wrap gap-x-4 gap-y-2 justify-center items-center",
        testResult === undefined && "bg-slate-700",
        testResult === true && "bg-green-500",
        testResult === false && "bg-red-500"
      )}
      data-type="row"
      onDrop={handleDrop}
      onDragOver={handleDragOver}  
    > 
      { row.groups.map( (group:any) => (
        <ConditionalGroupBlock key={group.groupref} group={group} zoneref={row.zoneref} />
      ))}

    </div>
  )
}



/*
{ store.metas.conditionalTest !== null && (
        <div className="absolute right-0 top-0 w-8 h-full flex justify-center items-center">
          {/* { store.metas.conditionalTest.details.zones.find( (zoneObj:any) => zoneObj.zone === zone )?.verdict === true && (
            <Check className="w-6 h-6 text-green-500" />
          )}

          { store.metas.conditionalTest.details.zones.find( (zoneObj:any) => zoneObj.zone === zone )?.verdict === false && (
            <X className="w-6 h-6 text-red-500" />
          )}
          </div>
        )}
*/